import { render, staticRenderFns } from "./wt-selector.vue?vue&type=template&id=87e73cc6"
import script from "./wt-selector.vue?vue&type=script&lang=js"
export * from "./wt-selector.vue?vue&type=script&lang=js"
import style0 from "./wt-selector.vue?vue&type=style&index=0&id=87e73cc6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports